<template>
    <div class="fullpage-modal__header secondary-text">
        <transition name="fade" mode="out-in">
            <button v-if="showBack"
                    type="button"
                    class="round-icon-button secondary-text"
                    :aria-label="backLabel"
                    @click="$emit('back')"
            >
                <span class="icon-arrow rotate-180"></span>
            </button>
            <div v-if="!showBack">
                <logo disableFocus></logo>
            </div>
        </transition>
        <button type="button"
                class="d-md-none round-icon-button primary-background"
                :aria-label="closeLabel"
                @click="$emit('close')"
        >
            <span class="icon-close secondary-text"></span>
        </button>
        <button type="button"
                class="d-none d-md-inline-block round-icon-button secondary-background"
                :aria-label="closeLabel"
                @click="$emit('close')"
        >
            <span class="icon-close primary-text"></span>
        </button>
        <button v-if="search"
                type="button"
                class="round-icon-button primary-background secondary-text d-md-none"
                :aria-label="closeLabel"
                @click="$emit('close-search')"
        >
            <span class="icon-menu"></span>
        </button>
        <button v-else
                type="button"
                class="round-icon-button primary-background secondary-text d-md-none"
                :aria-label="searchLabel"
                @click="$emit('open-search')"
        >
            <span class="icon-search"></span>
        </button>
        <lang-select disableFocus class="d-none d-md-block"></lang-select>
    </div>
</template>

<script>
    import { isOnDanish, translatedCloseLabel } from '../utils/is-on-language';

    export default {
        name: 'AppNavHeader',
        props: {
            search: {
                type: Boolean,
                required: true,
            },
            showBack: {
                type: Boolean,
                required: true,
            },
        },
        data () {
            return {
                closeLabel: translatedCloseLabel(),
                searchLabel: isOnDanish() ? 'Søg' : 'Search',
                backLabel: isOnDanish() ? 'Tilbage' : 'Back',
            };
        },
    };
</script>
